import { createSlice } from '@reduxjs/toolkit';

import { EnvironmentConfigResType } from '@/types/landingPageTypes';

import { EnvironmentConfigurationApi } from './EnvironmentConfigurationApi';

interface AllMachinesDataType {
  allMachinesData: EnvironmentConfigResType | [];
}
const initialState: AllMachinesDataType = {
  allMachinesData: [],
};

const allMachinesDataSlice = createSlice({
  name: 'allMachinesData',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addMatcher(
      EnvironmentConfigurationApi.endpoints.getEnvironmentConfiguration
        .matchFulfilled,
      (state, action: { payload: EnvironmentConfigResType }) => {
        state.allMachinesData = action.payload;
      },
    );
  },
});

export const allMachinesDataReducer = allMachinesDataSlice.reducer;
